export class Lightbox {

    constructor() {
        this.doc = $(document);

        const lity =  require('../../../libs/lity.min');

        // lightbox instance (initialized)
        this.lightbox = lity();

        // init (open with options)
        this.open = this.lightbox.open;

        // close member
        this.close = this.lightbox.close;

        this.init();
    }

    init() {
        // expose events to app ns
        $.each([
            "lity:open",
            "lity:ready",
            "lity:close",
            "lity:remove",
            "lity:resize"
        ], (i, ev) => {
            // pub event name (replace ns and camelCase)
            const name = ev.replace('lity:', 'on_').replace(/\_+(.)/g, (match, char) => {
                return char.toUpperCase();
            });

            // expose event callback (one event or on, unbound vs persistent)
            this[name] = (callback, unbounding) => {
                this.doc[(unbounding && "one" || "on")](ev, callback);
            };
        });

        //
        // bind as an event handler (delegated on doc)
        //
        this.doc.on("click", '[data-lightbox], [data-lightbox-ajax]', (e) => {

            const $this = $(e.target);

            // inline callback handler
            const ihandler = $this.attr("data-lightbox-handler");

            // AJAXED!
            if ($this.is('[data-lightbox-ajax]')) {
                e.preventDefault();
                this.ajax(e.target.href, ihandler);
                return;
            }

            this.lightbox.apply(e.target, [e]);

            ihandler && this.onOpen(function (ev, lbox, trigger) {
                const _self = this;

                try {
                    window[ihandler].apply(_self, [ev, lbox, trigger]);
                } catch(ex) {
                    console.log("provided inline handler "+ ihandler.toString() + " doesn't exist");
                }
            });

            // single unbounding events (true)
            this.onReady(this.lightBoxOnReady(e, $this), true);
        });

        // inlined close button
        this.doc.on("click", '.lightbox-close', (e) => {
            e.preventDefault();
            this.close();
        });
    }

    // invoque AJAX lightbox
    // programatically create an individual lightbox instance
    ajax(url, callback) {
        // inline layer and id
        const layerId = "layer_" + Math.random().toString().slice(10);
        const $ilayer = $('<div id="'+ layerId +'" class="lity-hide" />').appendTo("body");

        // fetch AJAX url
        $.get(url, (response) => {
            // inject content
            $ilayer.html(response);

            // up lightbox
            this.lightbox('#' + layerId);

            // exec callback
            callback && this.onOpen((ev, lbox, trigger) => {
                const _self = this;
                try {
                    window[callback].apply(_self, [ev, lbox, trigger]);
                } catch(ex) {
                    console.debug("provided handler "+ callback.toString() + " doesn't exist");
                }
            });
        });
    };

    lightBoxOnReady(ev, lbox) {
        const $target = $(ev.target);

        this.hookCloseButton(lbox);

        // don't let close on outside click if provided
        // @TODO: lock via options?
        if ($target.attr("data-lightbox-locked")) {
            lbox.addClass("lightbox-locked")
                .find(".lity-wrap")
                .removeAttr("data-lity-close");
        }
    }

    // if an inline closer is provided, hide native closer
    hookCloseButton(lbox) {
        const lboxClose = lbox.find(".lightbox-close");
        const lityClose = lbox.find(".lity-close");

        if (lboxClose.length) {
            lityClose.css("display", "none");
        }
    }
}
